/*
 * @Author: Hyman Choi
 * @Date: 2021-02-02 11:05:12
 * @LastEditTime: 2021-11-16 16:05:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\mai\eventManagement\eventDetail.js
 */
import request from "@/utils/request";
import config from "@/utils/config";

/**
 * @description: 后台管理获取单个活动详情
 * @param {*} params
 * @return {*}
 */
export function getOne(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminActivitys/One",
		method: "get",
		params,
	});
}

/**
 * @description: 后台更新活动
 * @param {*} data
 * @return {*}
 */
export function updateActivity(data) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminActivitys/Update",
		method: "post",
		data,
	});
}

/**
 * @description: 后台管理获取活动的所有奖项
 * @param {*} params
 * @return {*}
 */
export function getAward(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminActivitys/LuckyDrawsList",
		method: "get",
		params,
	});
}

/**
 * @description: 后台更新活动奖项
 * @param {*} data
 * @return {*}
 */
export function updateAward(data) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminActivitys/LuckyDraw/Update",
		method: "post",
		data,
	});
}

/**
 * @description: 后台管理添加活动奖项
 * @param {*} data
 * @return {*}
 */
export function addAward(data) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminActivitys/LuckyDraw/Add",
		method: "post",
		data,
	});
}

/**
 * @description: 后台管理分页查询指定活动所有的用户数据
 * @param {*} params
 * @return {*}
 */
export function getUserList(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminActivitys/ActivityUserList",
		method: "get",
		params,
	});
}

/**
 * @description: 后台删除或者恢复活动参与用户
 * @param {*} params
 * @return {*}
 */
export function deleteOrBackUser(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminActivitys/ActivityUser/DeleteOrBack",
		method: "get",
		params,
	});
}

/**
 * @description: 后台管理分页获取所有的中奖用户
 * @param {*} params
 * @return {*}
 */
export function getWinningUserList(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/AdminActivitys/LuckyDrawUserList",
		method: "get",
		params,
	});
}

/**
 * @description: 后台设置或者取消设置特殊用户
 * @param {*} params
 * @return {*}
 */
export function setSpecialUser(params) {
	return request({
		url:
			config.API_MEDICAL + "/Api/V1/AdminActivitys/ActivityUser/SpecialOrCancel",
		method: "post",
		params,
	});
}
